import { onBeforeMount, onBeforeUnmount, ref } from "vue";
import { isPCFunc } from "@/utils/predicates";

const uesUpdateSize = (callBack) => {
    const isPc = ref(true);
    const isShowDom = ref(false);

    function updateSize() {
        if (document.documentElement.clientWidth <= 640) {
            isPc.value = false;
        } else {
            isPc.value = isPCFunc();
        }
        callBack && callBack();
    }

    onBeforeMount(() => {
        if (!window.__PRERENDER_INJECTED || window.__PRERENDER_INJECTED.isPrerender !== true) {
            isShowDom.value = true;
            isPc.value = isPCFunc();
        }
        window.addEventListener("resize", updateSize, true);
    });

    onBeforeUnmount(() => {
        window.removeEventListener("resize", updateSize, true);
    });

    return {
        isPc,
        isShowDom,
    };
};

export default uesUpdateSize;
